import { IApiService } from '~/services/interfaces/IApiService';
import {
    BaseGlobalContext,
    BaseGlobalContextValue
} from '~/providers/base-global-context/base-global.context';
import { UnauthenticatedApiService } from '~/services/unauthenticated-api.service';
import { UnauthenticatedAnalyticsService } from '~/services/unauthenticated-analytics.service';
import { IAnalyticsService } from '~/services/interfaces/IAnalyticsService';

export interface UnauthenticatedGlobalContextValue
    extends BaseGlobalContextValue {}

export class UnauthenticatedGlobalContext
    extends BaseGlobalContext
    implements UnauthenticatedGlobalContextValue
{
    analyticsService: IAnalyticsService;

    constructor() {
        super();

        // Util services
        this.analyticsService = new UnauthenticatedAnalyticsService({
            configStore: this.configStore,
            fullstoryService: this.fullstoryService
        });
    }

    initApiServices(): IApiService {
        return new UnauthenticatedApiService(this);
    }
}
